import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './dialog';
import { Button } from './button';
import { AlertTriangle, Trash2, Loader2 } from 'lucide-react';

const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "Confirmer la suppression",
  description = "Cette action est irréversible. Êtes-vous sûr de vouloir continuer ?",
  confirmText = "Supprimer",
  cancelText = "Annuler",
  onConfirm,
  loading = false,
  variant = "destructive" // "destructive" | "warning" | "default"
}) => {
  const variantStyles = {
    destructive: {
      icon: <Trash2 className="h-6 w-6 text-red-600" />,
      iconBg: "bg-red-100",
      button: "bg-red-600 hover:bg-red-700 text-white"
    },
    warning: {
      icon: <AlertTriangle className="h-6 w-6 text-amber-600" />,
      iconBg: "bg-amber-100",
      button: "bg-amber-600 hover:bg-amber-700 text-white"
    },
    default: {
      icon: <AlertTriangle className="h-6 w-6 text-blue-600" />,
      iconBg: "bg-blue-100",
      button: "bg-blue-600 hover:bg-blue-700 text-white"
    }
  };

  const styles = variantStyles[variant] || variantStyles.destructive;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-4">
            <div className={`p-3 rounded-full ${styles.iconBg}`}>
              {styles.icon}
            </div>
            <div>
              <DialogTitle className="text-lg">{title}</DialogTitle>
              <DialogDescription className="mt-1">
                {description}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <DialogFooter className="mt-6 flex gap-3 sm:gap-3">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
            className="flex-1"
          >
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 ${styles.button}`}
            data-testid="confirm-delete-btn"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Suppression...
              </>
            ) : (
              confirmText
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
